const MIN_DESKTOP_WIDTH = 734

export const STICKY_HEADER_SHADOW = 'rgba(0, 0, 0, 0.05) 0px 2px 20px'
export const STICKY_FOOTER_SHADOW = 'rgba(0, 0, 0, 0.05) 0px -2px 20px'

export const STICKY_FOOTER_INNER_PADDING = '10px 14px'
export const STICKY_FOOTER_BUTTON_GAP = 8
export const STICKY_FOOTER_BUTTON_AREA_PADDING_BOTTOM = 5
export const STICKY_FOOTER_BENEFITS_CAROUSEL_PADDING_BOTTOM = 5
export const STICKY_FOOTER_NON_CART_ACTION_MARGIN = 20
export const STICKY_FOOTER_SAFE_AREA_PADDING = 'env(safe-area-inset-bottom)'

export function getStickyFooterSafeAreaPadding(
    hasBrandBenefits: boolean,
): string {
    return hasBrandBenefits ? '0px' : STICKY_FOOTER_SAFE_AREA_PADDING
}

export const Constants = {
    EXPANDED_BREAKPOINT: MIN_DESKTOP_WIDTH,
    CONTENT_BLOCK_DESKTOP_WIDTH: 470,
    CONTENT_BLOCK_MOBILE_MARGIN: 24,
    EDITOR_SCROLL_OFFSET: 115,
    // Base vertical spacing unit for native storefront sections. Drives
    // SectionContainer padding, SectionTitle margin-bottom, and the
    // below-heading / between-block rhythm used across section internals.
    SECTION_BASE_SPACING_PX: 12,
}
